import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {NodeStatus} from "../../../../modules/workflow/enums/NodeStatus";
import {NodeDto} from "../../../../modules/workflow/dto/NodeDto";
import EnumItemLabel from "../../../../components/EnumItemLabel";
import dayjs from "dayjs";
import {Formats} from "../../../../constants/Formats";
import {FlowDto} from "../../../../modules/workflow/dto/FlowDto";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {FlowApi} from "../../../../modules/workflow/api/FlowApi";
import {
    Chip,
    Stack,
    Step,
    Stepper, Typography
} from "@mui/material";
import {useConfirm} from "material-ui-confirm";
import ApproveButton from "../../../../components/buttons/ApproveButton";
import RejectButton from "../../../../components/buttons/RejectButton";
import RejectDialog from "./RejectDialog";

export type ApproveTimeLineProps = {
    context: string;
    onApprove?: () => void;
    onReject?: (remarks: string) => void;
    canApprove?: boolean;
};

const ApproveTimeLine: React.FC<ApproveTimeLineProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();

    const [flows, setFlows] = useState<Array<FlowDto>>([]);
    const [openRejectDialog, setOpenRejectDialog] = useState(false);
    const [rejectRemarks, setRejectRemarks] = useState('');

    useEffect(() => {
        console.log(props.context);
        if (props.context) {
            // 查询访问目的字典项
            fetchFlows();
        }
    }, [props.context]);

    const fetchFlows = async () => {
        const responseResult = await FlowApi.getFlowsByContext(props.context);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setFlows(responseResult.data);
        }
    };

    const _renderNode = (node: NodeDto, index: number) => {
        let statusColor = "gray";
        switch (node.status) {
            case NodeStatus.Enum.Approved:
                statusColor = "green";
                break;
            case NodeStatus.Enum.Rejected:
                statusColor = "red";
                break;
        }

        return (
            <Step color={statusColor} key={index}>
                {_renderNodeHeader(node)}
                {_renderNodeExecutors(node)}
            </Step>
        );
    }

    const _renderNodeHeader = (node: NodeDto) => {
        let statusColor = "default";
        switch (node.status) {
            case NodeStatus.Enum.Approved:
                statusColor = "success";
                break;
            case NodeStatus.Enum.Rejected:
                statusColor = "error";
                break;
        }

        return (
            <div>
                <div>
                    <span>{node.name}{_renderThreadExecutorRanges(node)}</span>
                    {/*// @ts-ignore*/}
                    <Chip color={statusColor} size="small"
                          label={<EnumItemLabel value={node.status} map={NodeStatus.Map}/>}/>
                </div>
                <br/>
                <div>
                    <span>{node.finishTime ? dayjs(node.finishTime, Formats.DATE_TIME_SIMPLE).format(Formats.DATE_TIME_HYPHEN) : ""}</span>
                </div>
                <div>{node.remarks}</div>
            </div>
        )
    }

    const _renderThreadExecutorRanges = (thread: NodeDto) => {
        if (!thread.executorRanges || thread.executorRanges.length <= 0) {
            return null;
        }

        let executorNames = thread.executorRanges.map((item) => {
            return item.name
        }).join(',');

        return (
            <span>（{executorNames}）</span>
        );
    }

    const handleApprove = () => {
        confirm({title: intl.formatMessage({id: 'WORKFLOW_PROCESS_APPROVE_CONFIRM'})})
            .then(() => {
                if (props.onApprove) {
                    props.onApprove();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    }

    const _renderNodeExecutors = (node: NodeDto) => {
        console.log(node);
        let statusColor = "default";
        switch (node.status) {
            case NodeStatus.Enum.Approved:
                statusColor = "success";
                break;
            case NodeStatus.Enum.Rejected:
                statusColor = "error";
                break;
        }

        return (
            <div>
                {
                    node.executors && node.executors.map((item, index) => {

                        return (
                            <div key={index}>
                                <div>
                                    <span>{item.name}</span>&nbsp;
                                    {/*// @ts-ignore*/}
                                    <Chip color={statusColor} size="small"
                                          label={<EnumItemLabel value={item.executeResult} map={NodeStatus.Map}/>}/>
                                    &nbsp;
                                    {item.deputyFlag ?
                                        <Chip color="success" size="small" label={<FormattedMessage
                                            id={'WORKFLOW_APPLY_THREAD_EXECUTOR_DEPUTY_FLAG'}/>}/> : null}
                                </div>
                            </div>
                        )
                    })
                }
                {
                    props.canApprove && node.currentUserCanApprove ?
                        <Stack direction={'row'} spacing={2}>
                            <ApproveButton onClick={handleApprove}/>
                            <RejectButton onClick={() => setOpenRejectDialog(true)}/>
                        </Stack> : null
                }
            </div>
        );
    }

    const flow = flows.length > 0 ? flows[0] : new FlowDto();
    return (
        <div>
            <RejectDialog onCancel={() => setOpenRejectDialog(false)} onOk={(value) => {
                setOpenRejectDialog(false);
                props.onReject && props.onReject(value);
            }} open={openRejectDialog}/>
            <Typography variant="h6" gutterBottom>
                {flow.name}
            </Typography>
            <Stepper orientation="vertical">
                {
                    flow.nodes.map((item: NodeDto, index: number) => {
                        return _renderNode(item, index);
                    })
                }
            </Stepper>
        </div>
    );
};

export default ApproveTimeLine;
